import type { FaireProductEntity } from "../../entity_types/product";

export const p_r5wpwumgek: FaireProductEntity = {
  token: "p_r5wpwumgek",
  type: "product",
  name: "God is Kind",
  brandToken: "b_14eeavl3ro",
  brandName: "Sourcebooks",
  imageUrl:
    "https://cdn.faire.com/fastly/aaa2edad15bbaba0514a9c20fb38fb0ac6743232c2680d6ae2a639488f57adac.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b4ea8c5ed331f86907641e7f3fa4ceca5b2a067c6f9e9448c54b71792f6bb56f.jpeg",
    "https://cdn.faire.com/fastly/a1c8c8aedace572706d8ce6c2490ea33947175bfb5a0e4ee5b042a2db5f13a4d.jpeg",
    "https://cdn.faire.com/fastly/35d3ee7e13adf6ea135541c4216276586a0670617bff5522bbb0e5349f8ac499.jpeg",
  ],
  priceDollars: 6.93,
  description:
    "Share the beautiful message of God's gift of kindness with this heartfelt read aloud, perfect for babies and toddlers all year round! Combining an important lesson on kindness with light Christian themes, this sweet board book taps into the bestselling children's inspiration space in a brand-new way.\n\nDear little one, I have good news for you:\n\nGod's kindness is in all that we see and do!",
  tags: [],
  msrpDollars: 13.84,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:18.404Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
